import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/404.module.css';
import { FaDiscord } from 'react-icons/fa';

export default function OutOfStock() {
  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorContent}>
        <div className={styles.number}>Out</div>
        <div className="flex items-center">
          <div className={styles.circle}></div>
          <div className={`${styles.number} -ml-4`}>f Stock</div>
        </div>
        <div className="w-full">
          <p className={styles.text}>Out of Stock</p>
          <p className="text-gray-400 mb-6">
            This product is currently out of stock. Please contact us on Discord for assistance.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://discord.gg/olymp4"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.button} flex items-center gap-2`}
            >
              <FaDiscord className="text-xl" />
              Join Discord
            </a>
            <Link to="/" className={styles.button}>
              Return to Store
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
} 